const EDITOR_REDUCER_NAME = 'editor';

const ACHIEVEMENT_MODAL_KEYS = {
  MODAL_VISIBLE: 'isAchievementModalVisible',
  USING_CHIP: 'isUsingAchievementChip',
  USING_EDIT_MODE: 'isUsingEditMode',
};

const CHOICE_KEYS = {
  HIDE: 'hide',
  REQUIRED: 'required',
  REQUIRED_SPONSOR_COOKIE: 'requiredSponsorCookie',
};

const CHOICE_RESULT_KEYS = {
  STORE: 'store',
  STORE_HIDDEN: 'storeHidden',
  DESTROY: 'destroy',
  DESTROY_HIDDEN: 'destroyHidden',
  CHANGE_STATUS: 'changeStatus',
  PROBABILITY: 'probability',
  ACHIEVEMENT: 'achievement',
  REQUIRED_ITEMS: 'requiredItems',
  RESULTPROPERTY_CHIPSTATE: 'resultPropertyChipState',
  CHOICEPROPERTY_CHIPSTATE: 'choicePropertyChipState',
};

const ITEM_TEXT_DELIMITER_TYPE = {
  SPLIT: ',',
  HIDDEN_ITEM: '@',
  MULTIPLE_ITEM: '*',
};

export { EDITOR_REDUCER_NAME, ACHIEVEMENT_MODAL_KEYS, CHOICE_KEYS, CHOICE_RESULT_KEYS, ITEM_TEXT_DELIMITER_TYPE };
